// extracted by mini-css-extract-plugin
export var container = "styles-module--container--bafd7";
export var desktop = "1340px";
export var giant = "2200px";
export var icon = "styles-module--icon--c483e";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var quote = "styles-module--quote--ec3b8";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var sourceCaption = "styles-module--sourceCaption--c8aea";
export var tablet = "768px";